<div mdbModal #verPago="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-fluid" style="width: 80%;" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Detalle pago Realizado por: {{nombreRecaudador}}
        </h4>


        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="verPago.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body FontCabecera">
        <div class="row filtros-body">
          <div class="col" style="max-width: 20%;">
            <p>Cliente: {{cliente_nombre}}</p>
          </div>
          <div class="col">
            <p>Cond. Pago: {{condicion_pago}}</p>
          </div>
        </div>
      </div>
      <div class="modal-body">
        <div class="row filtros-body">
          <div class="col">
            <h5>Documentos Pagados</h5>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table table-striped table-hover table-sm align-middle">
            <thead class="grey lighten-2">
              <tr>
                <!-- <th scope="col">
                                    <mdb-checkbox></mdb-checkbox>
                                </th> -->
                <th scope="col">Documentos</th>
                <th scope="col">Ref. Doc. Nro.</th>
                <th scope="col">Vendedor</th>
                <th scope="col">Emisión</th>
                <th scope="col">Vencimiento</th>
                <th scope="col" class="text-right">Monto</th>
                <th scope="col" class="text-right">Pagos</th>
                <!-- <th scope="col">Abonar</th> -->
                <th scope="col" class="text-right">Deuda</th>
                <!-- <th scope="col">Recorrido</th> -->
                <!-- <th scope="col">Estado Rec.</th> -->
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="loading">
                <td colspan="100%" style="text-align: center">
                  <mdb-spinner spinnerColor="blue"></mdb-spinner>
                </td>
              </tr>
              <tr *ngIf="!loading && pago?.saldoDocumento.length === 0">
                <td colspan="100%" style="text-align: center">
                  No se encontró información
                </td>
              </tr>
              <tr *ngFor="let mov of pago?.saldoDocumento">
                <!-- <td>
                                    <mdb-checkbox></mdb-checkbox>
                                </td> -->
                <td>{{mov.tipo_pago}}</td>
                <td>{{mov.ref_doc}}</td>
                <td>{{mov.vendedor_nombre}}</td>
                <td>{{mov.fecha_emision | fecha}}</td>
                <td>{{mov.fechaVencimientoDocto | fecha}}</td>
                <td align="right">$ {{mov.monto | numerico}}</td>
                <td align="right">$ {{mov.pago | numerico}}</td>
                <!-- <td style="width: 100px;" align="right">
                                    <input type="text" id="input11" class="form-control" placeholder=""
                                        [(ngModel)]="mov.abono" onlyNumbers />
                                </td> -->
                <td align="right">$ {{mov.saldo | numerico}}</td>
                <!-- <td></td> -->
                <!-- <td></td> -->
              </tr>
            </tbody>
            <tbody class="blue lighten-5" *ngIf="pago?.saldoDocumento.length > 0">
              <tr>
                <!-- <td></td> -->
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td align="right"><strong>Totales</strong></td>
                <td align="right"><strong>$ {{pago.totales.saldoDocumento.monto | numerico}}</strong>
                </td>
                <td align="right"><strong>$ {{pago.totales.saldoDocumento.pago | numerico}}</strong>
                </td>
                <!-- <td align="right"><strong>$ {{pago.totales.saldoDocumento.abono | numerico}}</strong>
                                </td> -->
                <td align="right"><strong>$ {{pago.totales.saldoDocumento.saldo | numerico}}</strong>
                </td>
                <!-- <td></td> -->
                <!-- <td></td> -->
              </tr>
            </tbody>
          </table>
        </div>
        <div *ngIf="pago?.difereciaPago.length !== 0">
          <div class="row filtros-body">
            <div class="col">
              <h5>Pagos a cuentas</h5>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table table-striped table-hover table-sm align-middle">
              <thead class="grey lighten-2">
                <tr>
                  <!-- <th scope="col">
                                      <mdb-checkbox></mdb-checkbox>
                                  </th> -->
                  <th scope="col">Tipo pago a cuenta</th>
                  <th scope="col">Ref. Doc. Nro.</th>
                  <th scope="col">Fecha Doc.</th>
                  <th scope="col">Monto</th>
                  <!-- <th scope="col">Pago a cuenta a utilizar</th> -->
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="loading">
                  <td colspan="100%" style="text-align: center">
                    <mdb-spinner spinnerColor="blue"></mdb-spinner>
                  </td>
                </tr>
                <!-- <tr *ngIf="!loading && pago?.difereciaPago.length === 0">
                                  <td colspan="100%" style="text-align: center">
                                      No se encontró información
                                  </td>
                              </tr> -->
                <tr *ngFor="let mov of pago?.difereciaPago">
                  <!-- <td>
                                      <mdb-checkbox></mdb-checkbox>
                                  </td> -->
                  <td>{{mov.tipo_pago_cuenta_nombre}}</td>
                  <td>{{mov.referencia_documento}}</td>
                  <td>{{mov.fecha_doc | fecha}}</td>
                  <td align="right">$ {{mov.saldo}}</td>
                  <!-- <td style="width: 200px;" align="right">
                                      <input type="text" id="input11" class="form-control" placeholder=""
                                          [(ngModel)]="mov.pagoAUtilizar" />
                                  </td> -->
                </tr>
              </tbody>
              <tbody class="blue lighten-5" *ngIf="pago?.difereciaPago.length > 0">
                <tr>
                  <td align="right" colspan="3">
                    <strong>Total de pago a cuenta</strong>
                  </td>
                  <td align="right"><strong>$ {{pago.totales.difereciaPago.saldo | numerico}}</strong>
                  </td>
                  <!-- <td align="right"><strong>$ {{pago.totales.difereciaPago.pagoAUtilizar |
                                          numerico}}</strong></td> -->
                </tr>
              </tbody>
            </table>
          </div>

        </div>
        <div class="row filtros-body">
          <div class="col">
            <h5>Formas de pago</h5>
          </div>
        </div>
        <div class="table-responsive mt-1">
          <table class="table table-striped table-hover table-sm align-middle">
            <thead class="grey lighten-2">
              <tr>
                <!-- <th scope="col">
                                    <mdb-checkbox></mdb-checkbox>
                                </th> -->
                <th scope="col">Descripción</th>
                <th></th>
                <th scope="col">Nro. Doc.</th>
                <th scope="col">Nro. Cuenta</th>
                <th scope="col">Banco</th>
                <th scope="col">Fecha</th>
                <th scope="col">F. Deposito</th>
                <th scope="col" style="text-align: end;">Monto</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="loading">
                <td colspan="100%" style="text-align: center">
                  <mdb-spinner spinnerColor="blue"></mdb-spinner>
                </td>
              </tr>
              <tr *ngIf="!loading && pago?.forma_pago.length === 0">
                <td colspan="100%" style="text-align: center">
                  No se encontró información
                </td>
              </tr>
              <tr *ngFor="let mov of pago?.forma_pago">
                <!-- <td>
                                    <mdb-checkbox></mdb-checkbox>
                                </td> -->
                <td>{{mov.tipo_pago_nombre}}</td>
                <th></th>
                <td>
                  <ng-container *ngIf="mov.numero_doc > 0">
                    {{mov.numero_doc}}
                  </ng-container>
                </td>
                <td>
                  {{mov.numero_cuenta}}
                </td>
                <td>{{ mov.banco_nombre }}</td>
                <td>{{ mov.fecha_vencimiento | fecha}}</td>
                <td>{{mov.fecha_vencDep | fecha}}</td>
                <td align="right">$ {{mov.monto | numerico}}</td>
              </tr>
            </tbody>
            <tbody class="blue lighten-5" *ngIf="pago?.forma_pago.length > 0">
              <tr>
                <td align="right" colspan="7">
                  <strong>Total forma de pago</strong>
                </td>
                <td align="right"><strong>$ {{pago.totales.forma_pago | numerico}}</strong></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="verPago.hide()"
          mdbWavesEffect>
          Cerrar
        </button>

        <button mdbBtn type="button" color="primary" mdbWavesEffect class="btn" (click)="downloadExcelPdf('PDF')">
          PDF
        </button>
      </div>
    </div>
  </div>
</div>